module.exports = __webpack_public_path__ + "img/MemeETC (1).930fc82a.jpeg";